export default __webpack_public_path__ + "static/media/TrivaGame.2db1e352.png";